import { useMutation } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";
import { useGetMyProfile } from "../profile/use-get-my-profile";

export const useCreateAgencySaleDetail = () => {
  const { invalidate } = useGetMyProfile();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: agencySaleDetail.create,
    onSettled: invalidate,
  });

  return {
    create: mutateAsync,
    isLoading,
  };
};
